import { useState } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../inputs/Checkbox';
import caret from '../../assets/svg/caret.svg';
import circle from '../../assets/svg/circle.svg';
import pascalCaseToWords from '../../utils/pascalCaseToWords';

const BillItem = ({
  label,
  date,
  id,
  price,
  breakdown,
  showCheckbox,
  isPosted,
  isSelected,
  isPayingPerItem,
  toggleItemIsSelected,
}) => {
  const [showBreakdown, setShowBreakdown] = useState(false);
  const showBreakdownCaret = !showCheckbox;
  const toggleShowBreakdown = () => {
    if (breakdown.length !== 0) {
      setShowBreakdown((prev) => !prev);
    }
  };

  const breakdownList = (
    <div className="pb-2 pt-3">
      {breakdown
        && breakdown.map((item) => (
          <div
            className="flex items-center justify-between gap-4 pt-1 xxs:gap-6"
            key={item.id}
          >
            <img className="px-2" src={circle} alt="" />
            <span className="text-left">{item.label}</span>
            <span className="ml-auto text-right">
              Net:
              {' '}
              {item.unitPrice && item.unitPrice.toFixed(2)}
            </span>
          </div>
        ))}
    </div>
  );

  const handleClick = (e) => {
    e.preventDefault();
    if (showCheckbox) {
      toggleItemIsSelected(id);
    } else if (!isPayingPerItem) {
      toggleShowBreakdown();
    }
  };

  return (
    <button className={`flex items-center gap-2 ${!isPosted && 'text-gray-400'}`} onClick={(e) => handleClick(e)}>
      {showCheckbox && <Checkbox id={id} checked={isSelected} />}
      <div className="flex w-full flex-col rounded-lg bg-pj-gray-500 p-1">
        <div
          className={`flex gap-4 p-2 duration-200 xxs:gap-6 ${
            showBreakdown && 'rounded-b-none border-b border-b-pj-gray-600 pb-2'
          }`}
        >
          {showBreakdownCaret && (
            <div
              className="size-6 min-w-6 cursor-pointer border-none bg-transparent p-0 outline-none"
              aria-label={`expand ${label} details`}
            >
              {breakdown?.length > 0 && (<img src={caret} alt={`expand ${label} details`} />)}
            </div>
          )}
          <div className="flex flex-col items-start xxs:flex-row">
            <span className={`min-w-max text-sm ${isPosted ? 'text-pj-gray-750' : 'text-gray-400'}`}>{date}</span>
            <div className="text-left font-medium xxs:ml-4 sm:ml-6">{pascalCaseToWords(label)}</div>
          </div>
          <span className="ml-auto mt-auto">{price && price.toFixed(2)}</span>
        </div>
        <div className="px-2">{showBreakdown && breakdownList}</div>
      </div>
    </button>
  );
};

BillItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  showCheckbox: PropTypes.bool.isRequired,
  isPosted: PropTypes.bool.isRequired,
  date: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isPayingPerItem: PropTypes.bool.isRequired,
  toggleItemIsSelected: PropTypes.func.isRequired,
  breakdown: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      unitPrice: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default BillItem;
